export {KontaktProps} from "./kontakt.props";
export const name = "KontaktComponent";

